export var SDK_NAME = 'sentry.javascript.browser';
export var SDK_VERSION = '5.29.2';
//# sourceMappingURL=version.js.map